import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css';
import locale from 'element-ui/lib/locale/lang/en';
import request from "@/utils/request";
import store from "./store";
import 'highlight.js/styles/monokai-sublime.css'


Vue.config.productionTip = false

Vue.use(ElementUI, { locale });

Vue.use(ElementUI,{size: "mini"});

Vue.prototype.request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL || '/api'


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

